<template>
<div>
    <div  v-if="root.device!='phone'" class="mbg">
        <div class="yf-layout yf-layout-lt yf-cc myrow1">
         <img src='@/assets/login/ck.png'/>
          <div>歌莉娅数据可视化系统</div>
        </div>
        <div class="mswiper" :class="diveStyle">
                <div class="loginw" >

                     <div class="all_content">
                           <div class="yf-layout yf-layout-lt yf-cc all_input_row">
                               <img  src='@/assets/login/hyfx.png'/>
                               <input v-model="pcForm.username" type="text" placeholder="请输入用户名">
                           </div>
                           <div class="yf-layout yf-layout-lt yf-cc all_input_row">
                               <img  src='@/assets/login/gy.png'/>
                               <input v-model="pcForm.password"  type="password" placeholder="请输入密码">
                           </div>
                           <div class="all_input_row2" @click="goMain">
                               登录
                           </div>
                     </div>
                </div>
        </div>
    </div>
    <div  v-if="root.device=='phone'" class="phone_mbg">
        <div class="yf-layout yf-layout-lt yf-cc phone_row1">
         <img src='@/assets/login/ck.png'/>
          <div>歌莉娅数据可视化系统</div>
        </div>
        <div class="phone_mbg_mswiper">
                <div class="phone_mbg_mswiper_loginw" >

                     <img src="@/assets/login/loginw.png"/>
                     <div class="phone_content">
                           <div class="yf-layout yf-layout-lt yf-cc phone_input_row">
                               <img  src='@/assets/login/hyfx.png'/>
                               <input v-model="phoneForm.username" type="text" placeholder="请输入用户名">
                           </div>
                           <div class="yf-layout yf-layout-lt yf-cc phone_input_row">
                               <img  src='@/assets/login/gy.png'/>
                               <input v-model="phoneForm.password" type="password" placeholder="请输入密码">
                           </div>
                           <div class="phone_input_row2" @click="goMain">
                               登录
                           </div>
                     </div>
                </div>
        </div>
    </div>
</div>

</template>
<script>
import {login,menu} from '@/api/login.js' // 权限判断指令
import {setToken} from '@/api/common.js'
import axios from 'axios'
import storage from 'good-storage'
export default {
     inject:['root'],
     data(){
         return {
            swiperOptions:{
                slidesPerView: this.root.device=='pc'?4:3,
                 spaceBetween: 5,

                // centeredSlides: true,
               autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
			form:{
				username:undefined,
				password:undefined
			},
			pcForm:{
				username:undefined,
				password:undefined
			},
			phoneForm:{
				username:undefined,
				password:undefined
			}

         }
     },
     computed:{
       diveStyle:function(){
           const list=[];
           list.push(this.root.device)
           return list;
       }
     },
    methods:{
       goMain(){
			if(!this.validityFrom()){
			   return;
			}
			var _this = this;
		   login(this.from).then(function (res) {
		       console.log(res);
			   if(res.code!=0){
					_this.$toast({
						text: res.msg,
						type: 'wraning',
				    })
			   }else{
				   setToken(res.token)
				//    storage.session.set("permiss", res.menu)
                let permiss=JSON.stringify(res.menu)
                localStorage.setItem("permiss", permiss)
				   location.reload(true)
			   }
		   })
       },
	   validityFrom(){
		   if(this.root.device=='phone'){
			   this.from = this.phoneForm
		   }else{
			   this.from = this.pcForm
		   }
		   if(!this.from.username){
				this.$toast({
					text: '用户名不能为空',
					type: 'wraning',
					// duration: 3000
				 })
			   return false;
		   }else if(!this.from.password){
				this.$toast({
					text: '密码不能为空',
					type: 'wraning',
				 })
			   return false;
		   }
		   return true;

	   },
    },
    mounted(){

    }
}
</script>
<style lang='scss' scoped>
.myrow1{
    img{
        width:5vw;
        margin-right: 10px;
    }
    margin-top: -100px;
    margin-bottom: 100px;
    color: #fff;
    font-size: 80px;
}
.phone_row1{
    img{
        width:8vw;
        margin-right: 1vw;
    }
     color: #fff;
    font-size: 7vw;
    margin-bottom: 8vw;

}
.mbg{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
     background-image:url('../../assets/login/loginbg.png') ;
    .loginw{
                width:608px;
                height: 440px;
    }
}
*{
    margin: 0px;
    padding: 0px;
}
html, body {
      position: relative;
      height: 100%;
    }
    body {
      background: #eee;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14px;
      color:#000;
      margin: 0;
      padding: 0;
    }

    :focus {
        outline: none;
    }
    .loginw{
        background-image: url('../../assets/login/loginw.png');
        background-size:100% ;
        position: relative;
        background-repeat:no-repeat;
    }
.phone_mbg{

      background-size: cover;
      height: 100%;
      background-image:url('../../assets/login/loginbg2.png') ;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-position: center;
}
    .phone_mbg_mswiper_loginw{

         width:70%;
         position: relative;
         margin: auto;
        img{
           width:100%
        }
    }
    .phone_content{
        position: absolute;
        top:0px;
        left:0px;
        width:100%;
        height:100%;
            display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    }
    .phone_input_row{
        background: #000000;
        border: 1px solid #4EADFF;
        border-radius: 20px;
        border-radius: 20px;
        height: 10vw;

        width:75%;
        img{
            width:5vw;

            margin-left: 30px;
            margin-right: 50px;
        }
        input{
            background: none;
            border: 0px;
            flex:1;
            color: rgba(255,255,255,0.76);
        }
        margin-bottom: 2vw;
    }
        .phone_input_row2{
            margin-top: 1vw;
           background-image: linear-gradient(180deg, #4EADFF 0%, #0094FD 100%);
            border-radius: 20px;
            border-radius: 20px;
            height: 10vw;
            width:75%;
            line-height: 10vw;
            text-align: center;
            color:#fff;
            cursor: pointer;
    }


.all_content{
        position: absolute;
        top:0px;
        left:0px;
        width:100%;
        height:100%;
            display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    }
    .all_input_row{
        background: #000000;
        border: 1px solid #4EADFF;
        border-radius: 20px;
        border-radius: 20px;
        height: 5vw;
                font-size: 28px;
        width:75%;
        img{
            width:3vw;

            margin-left: 15px;
            margin-right: 25px;
        }
        input{
            background: none;
            border: 0px;
            flex:1;
            color: rgba(255,255,255,0.76);
        }
        margin-bottom: 1vw;
    }
        .all_input_row2{
            font-size: 28px;
            margin-top: 0.5vw;
           background-image: linear-gradient(180deg, #4EADFF 0%, #0094FD 100%);
            border-radius: 20px;
            border-radius: 20px;
            height: 5vw;
            width:75%;
            line-height: 5vw;
            text-align: center;
            color:#fff;
            cursor: pointer;
    }
    .yf-layout{
        display: flex;
    }
    .yf-layout.yf-layout-tb{
       flex-direction: column;
    }
     .yf-layout.yf-layout-lf{
       flex-direction: row;
    }
   .yf-layout.yf-cc{
       align-items: center;
   }
</style>
